import React, { useState } from "react";
import { Box, Container, Text, VStack } from "@chakra-ui/react";
import NavBar from "../../../Components/Navbar/NavBar";
import SalesRJ from "./SalesRJ";
import ReportRJ from "./ReportRJ";
import rj_logo from "../../../Assets/rj_logo.png";

const RJ = () => {
  const [selectedOption, setSelectedOption] = useState("Sales");
  
  const handleTabClick = (tab) => {
    setSelectedOption(tab);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <SalesRJ content="Sales RJ" color="gray" />;
      case "Reports":
        return <ReportRJ content="Reports RJ" />;
      default:
        return <SalesRJ content="Sales RJ" color="gray" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar 
        tabIndicatorColor="gray.800" 
        logo={rj_logo} 
        onTabClick={handleTabClick} 
      />
      
      <Box bg="white" w="100%" h="calc(100vh - 60px)" overflow="hidden">
        {renderContent()}
      </Box>
    </Box>
  );
};

export default RJ;
